import { __awaiter } from "tslib";
import { getWebOOBExtensibilityServices } from '@1js/m365-ext-oob-providers';
import { getFeatureGates } from '@office-start/feature-gates-service';
import { storeAppId } from '../constants';
import { AppHostDevicePermissionService } from './AppHostDevicePermissionService';
import { DialogService } from './AppHostDialogService';
import { AppHostHubUiService } from './AppHostHubUiService';
import { AppInstallDialogService } from './AppHostInstallDialogService';
import { CacheabilityDataService, LifecycleService, } from './AppHostLifecycleService';
import { AppHostLinkService } from './AppHostLinkService';
import { AppHostLocationService } from './AppHostLocationService';
import { AppHostPageService } from './AppHostPageService';
import { ExtensibilityAppInfoService } from './ExtensibilityProviders/ExtensibilityAppInfoService';
import { NoOpDevicePermissionService } from './NoOpDevicePermissionService';
const copilotM365AppId = 'd870f6cd-4aa5-4d42-9626-ab690c041429';
export function createHubServices(args) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { addEventListenerCallback, appbarConnectorService, appId, appLinkDomains, appLinkRootPath, authenticationService, nestedAppAuthenticationService, capabilitiesFeatureGates, dialogHandlers, locStrings, navigateForwardCallback, navigateToAppCallback, officeComponentContext, retryCallback, setFrameInfoCallback, setShareLinkCallback, showConsentDialogCallback, telemetryService, userId, appInfo, userInfo, } = args;
        const hubUiService = new AppHostHubUiService(officeComponentContext.correlationId, retryCallback, locStrings, telemetryService, appId);
        const featureGates = (_a = getFeatureGates()) === null || _a === void 0 ? void 0 : _a.result;
        const pageService = new AppHostPageService(navigateForwardCallback, navigateToAppCallback, setShareLinkCallback, setFrameInfoCallback, addEventListenerCallback, {
            appLinkDomains,
            appLinkRootPath,
            appbarConnectorService,
        });
        const linkService = new AppHostLinkService(officeComponentContext.officeHomeApiRoot);
        const appInstallDialogService = new AppInstallDialogService();
        // TODO: all conditions when permission service should be disabled
        const permissionServiceDisabled = appId === storeAppId || !userId;
        const devicePermissionService = !permissionServiceDisabled
            ? ((_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.newDevicePermissionGates) === null || _b === void 0 ? void 0 : _b.newDevicePermissionEnabled) &&
                appId === copilotM365AppId
                ? new NoOpDevicePermissionService()
                : new AppHostDevicePermissionService(appId, userId, showConsentDialogCallback)
            : undefined;
        const locationService = !permissionServiceDisabled
            ? new AppHostLocationService()
            : undefined;
        const dialogService = capabilitiesFeatureGates.dialogServiceEnabled
            ? new DialogService(dialogHandlers)
            : undefined;
        const logger = {
            log(level, tag, message, exception) {
                return;
            },
        };
        const extensibilityServices = capabilitiesFeatureGates.copilotExtensibilityEnabled &&
            appInfo &&
            userInfo
            ? yield createExtensibilityServices({
                authenticationService,
                logger,
                appInfo,
                userInfo,
                capabilitiesFeatureGates,
            })
            : undefined;
        const hubServices = Object.assign({ appInstallDialogService,
            authenticationService,
            devicePermissionService,
            hubUiService,
            linkService,
            locationService,
            pageService,
            telemetryService, logger: logger }, extensibilityServices);
        hubServices.dialogService = dialogService;
        if (capabilitiesFeatureGates.nestedAppAuthServiceEnabled) {
            hubServices.nestedAppAuthService = nestedAppAuthenticationService;
        }
        if (capabilitiesFeatureGates.cachingEnabled) {
            const cacheabilityDataService = new CacheabilityDataService();
            const lifecycleService = new LifecycleService(cacheabilityDataService);
            hubServices.lifecycleService = lifecycleService;
        }
        return hubServices;
    });
}
function createExtensibilityServices(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { authenticationService, logger, appInfo, userInfo, capabilitiesFeatureGates, } = args;
        const harmonyAppService = new ExtensibilityAppInfoService();
        const extensibilityServices = yield getWebOOBExtensibilityServices(appInfo, userInfo, authenticationService, logger, harmonyAppService, {
            enableAppCommandService: capabilitiesFeatureGates.enableAppCommandService,
        });
        return extensibilityServices;
    });
}
//# sourceMappingURL=createHubServices.js.map